
import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 get_current_user_data: { status: "idle" },
};

export const get_current_user_data_Slice = createSlice({
 name: "get_current_user_data",
 initialState,
 reducers: {
  success_get_current_user_data: (state, action) => {
   const { token, ...log_cred } = action?.payload;
   localStorage.setItem('log_cred', JSON.stringify({ ...log_cred }));
   if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("authUpdated"));
   }

   state.get_current_user_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_get_current_user_data: (state, action) => {
   state.get_current_user_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_get_current_user_data: (state) => {
   state.get_current_user_data = { status: app_consts.IDLE };
  },
  loading_get_current_user_data: (state) => {
   state.get_current_user_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_get_current_user_data, fail_get_current_user_data, reset_get_current_user_data, loading_get_current_user_data } = get_current_user_data_Slice.actions;

export default get_current_user_data_Slice.reducer;
